import { gql } from '@apollo/client';
import { SaleItemGroupFragment } from '../fragments/SaleItemGroupFragment';
/**
 * @const SaleItemGroupsQuery
 * @since 1.0.0
 */
export const SaleItemGroupsQuery = gql `
  query SaleItemGroupsQuery($input: SaleItemGroupsInput) {
    saleItemGroups(input: $input) {
      ...SaleItemGroupFragment
    }
  }

  ${SaleItemGroupFragment}
`;
